import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import {
  userRegisterReducer,
  userSigninReducer,
  userSignoutReducer,
  userAddressMapReducer,
  userDetailsReducer,
  userUpdateProfileReducer,
} from "./userReducers";
import {
  addRecordReducer,
  recordMineListReducer,
  recordSummaryReducer,
  addYearlyReportReducer,
  listYearlyReportReducer,
  recordSearchReducer,
  recordCategoryListReducer,
  recordDeleteReducer,
  recordDetailsReducer,
  recordUpdateReducer,
  addCategoryReducer,
  categoryDeleteReducer,
  addTaxrateReducer,
  taxrateDetailsReducer,
  taxrateDeleteReducer,
  recordTaxrateListReducer,
  taxrateUpdateReducer,
} from "./financeRecordReducer";
import {
  addRptItemReducer,
  itemDetailsReducer,
  allRptItemReducer,
} from "./financeReportReducer";
import {
  productCategoryListReducer,
  productCreateReducer,
  productDeleteReducer,
  productDetailsReducer,
  productListReducer,
  productReviewCreateReducer,
  productUpdateReducer,
  UploadFileReducer,
  uploadedFilesListReducer,
} from "./productReducers";
/*
const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    */
const rootReducer = combineReducers({
  // rest of your reducers
  userSignin: userSigninReducer,
  userRegister: userRegisterReducer,
  userSignout: userSignoutReducer,
  addRecord: addRecordReducer,
  recordMineList: recordMineListReducer,
  recordSummary: recordSummaryReducer,
  addYearlyReport: addYearlyReportReducer,
  existedYearlyReport: listYearlyReportReducer,
  recordSearch: recordSearchReducer,
  recordCategoryList: recordCategoryListReducer,
  recordDelete: recordDeleteReducer,
  recordDetails: recordDetailsReducer,
  recordUpdate: recordUpdateReducer,
  userAddressMap: userAddressMapReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  addCategory: addCategoryReducer,
  categoryDelete: categoryDeleteReducer,
  addTaxrate: addTaxrateReducer,
  taxrateDetails: taxrateDetailsReducer,
  deleteTaxrate: taxrateDeleteReducer,
  recordTaxrateList: recordTaxrateListReducer,
  taxrateUpdate: taxrateUpdateReducer,
  addReportItem: addRptItemReducer,
  itemDetails: itemDetailsReducer,
  allRptItem: allRptItemReducer,
  productList: productListReducer,
  productDetails: productDetailsReducer,
  productCreate: productCreateReducer,
  productUpdate: productUpdateReducer,
  productDelete: productDeleteReducer,
  productCategoryList: productCategoryListReducer,
  productReviewCreate: productReviewCreateReducer,
  uploadFile: UploadFileReducer,
  uploadedFilesList: uploadedFilesListReducer,
});
export default rootReducer;
